window.Page = {

    // Let's launch this thing
    liftoff : () => {
        Page.initImageParallax()
    },

    // Initiate the parallax animation on the images
    initImageParallax : () => {
        let rellax = new Rellax('.motus-image-parallax');
    }

};

Page.liftoff()